export const datePickerCustomStyle = {
  slotProps: {
    textField: {
      InputProps: {
        sx: {
          '& .MuiInputBase-readOnly': {
            backgroundColor: 'white',
            cursor: 'pointer',
          },
        },
      },
    },
  },
};
